import { apiService } from "@/core/api";
import { API_ENDPOINTS } from "@/core/constants/endpoints";

/**
 * Response type for file upload operations
 */
interface FileUploadResponse {
  fid: Array<{ value: number }>;
  uuid: Array<{ value: string }>;
  uri: Array<{ value: string; url: string }>;
  filename: Array<{ value: string }>;
  filemime?: Array<{ value: string }>;
  filesize?: Array<{ value: number }>;
  status?: Array<{ value: boolean }>;
  created?: Array<{ value: string; format?: string }>;
  changed?: Array<{ value: string; format?: string }>;
}

export class FileUploadService {
  /**
   * Upload a file as raw binary (application/octet-stream)
   * This matches the Swagger/Drupal documentation requirement
   *
   * @param file - The file to upload
   * @returns The upload response with file details
   */
  async uploadFile(file: File): Promise<FileUploadResponse> {
    const entityTypeId = "user";
    const bundle = "user";
    const fieldName = "user_picture";

    const url = `${API_ENDPOINTS.FILES.UPLOAD}/${entityTypeId}/${bundle}/${fieldName}?_format=json`;

    // Read file as ArrayBuffer for binary upload
    const fileBuffer = await file.arrayBuffer();

    // console.log("Uploading file:", {
      // name: file.name,
      // size: file.size,
      // type: file.type,
      // url: url,
    // });

    // Use apiService with binary data and required headers
    const response = await apiService.post<FileUploadResponse>(
      url,
      fileBuffer,
      {
        headers: {
          "Content-Type": "application/octet-stream",
          "Content-Disposition": `file; filename="${file.name}"`,
          Accept: "application/json",
        },
      }
    );

    // console.log("Upload response:", response);

    if (!response || !response.uri) {
      throw new Error("Invalid response from server - missing URI");
    }

    return response;
  }

  /**
   * Step 2: Link the uploaded file to the user's profile picture
   * This endpoint associates the fid with the user's profile
   *
   * @param fid - The file ID received from the uploadFile endpoint
   * @returns The response from the update endpoint
   */
  async updateUserProfilePicture(fid: string): Promise<any> {
    return apiService.post(API_ENDPOINTS.USER.USER_PICTURE, {
      filename: fid,
    });
  }
}

// Export a singleton instance
export const fileUploadService = new FileUploadService();
